/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Edit(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M11 6H5.55556C5.143 6 4.74733 6.16389 4.45561 6.45561C4.16389 6.74733 4 7.143 4 7.55556V18.4444C4 18.857 4.16389 19.2527 4.45561 19.5444C4.74733 19.8361 5.143 20 5.55556 20H16.4444C16.857 20 17.2527 19.8361 17.5444 19.5444C17.8361 19.2527 18 18.857 18 18.4444V13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1791 4.48399C17.489 4.1741 17.9093 4 18.3476 4C18.7858 4 19.2061 4.1741 19.516 4.48399C19.8259 4.79388 20 5.21418 20 5.65243C20 6.09068 19.8259 6.51099 19.516 6.82088L12.1159 14.221L9 15L9.77896 11.8841L17.1791 4.48399Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Edit.defaultProps = {
  color: "currentColor",
  size: 24,
};

Edit.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
